import { MenuItem, Select } from "@mui/material"
import useLanguage from "hooks/use_language"
import useAppStore from "../../store/app"

const LanguageSelect = () => {
  const { language, languages, handleChange } = useLanguage()
  const { direction } = useAppStore((state) => state.meta)

  return (
    <Select
      fullWidth
      value={language}
      onChange={handleChange}
      sx={{
        backgroundColor: "#F8F8FA",
        borderRadius: "4px",
        height: "50px",
        fontWeight: 500,
      }}
    >
      {languages.map((lang, i) => (
        <MenuItem
          key={i}
          dir={direction}
          value={lang.code}
          sx={{ whiteSpace: "normal", minWidth: "388ox", gap: 4 }}
        >
          {lang.flag} {lang.name}
        </MenuItem>
      ))}
    </Select>
  )
}

export default LanguageSelect
